import styled from 'styled-components';
import SlingFormFieldStyle, {
  focusedStyle,
} from '@sdk/components/forms/components/SlingFormFieldStyle';
import { INPUT_HEIGHT } from '@sdk/components/forms/constants';

export const Textarea = styled.textarea<{ invalid: boolean }>`
  ${SlingFormFieldStyle}
  width: 100%;
  height: ${INPUT_HEIGHT * 2}px;
  margin-left: 23px;

  &:focus {
    ${focusedStyle}
  }

  ${({ invalid, theme }) => (invalid ? `border-color: ${theme.colors.danger}` : '')}
`;
